module.exports = __webpack_public_path__ + "assets/img/terminalPic9.9f0a5fa2.jpg";